import SocialProof from './SocialProof.vue'

export default SocialProof
